'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var OPTIONS_DATE_CALENDAR = { year: 'numeric', month: '2-digit', day: '2-digit' };

function getPeriods() {
  var currentDate = new Date();

  var yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  var currentWeekDate = new Date();
  currentWeekDate.setDate(currentWeekDate.getDate() - (currentWeekDate.getDay() > 0 ? currentWeekDate.getDay() : 7) + 1);

  var lastWeekStartDate = new Date();
  lastWeekStartDate.setDate(lastWeekStartDate.getDate() - (lastWeekStartDate.getDay() > 0 ? lastWeekStartDate.getDay() : 7) - 6);

  var lastTwoWeekEndDate = new Date();
  lastTwoWeekEndDate.setDate(lastTwoWeekEndDate.getDate() - (lastTwoWeekEndDate.getDay() > 0 ? lastTwoWeekEndDate.getDay() : 7));

  var thisMonthDate = new Date();
  thisMonthDate.setDate(1);

  var lastMonthEndDate = new Date();
  lastMonthEndDate.setDate(0);

  var lastMonthStartDate = new Date(lastMonthEndDate);
  lastMonthStartDate.setDate(1);

  var hotChanges = [{
    title: 'Сегодня',
    period: [currentDate, currentDate],
    isToday: true
  }, {
    title: 'Вчера',
    period: [yesterday, yesterday]
  }, {
    title: 'Эта неделя',
    period: [currentWeekDate, currentDate]
  }, {
    title: 'Прошлая неделя',
    period: [lastWeekStartDate, lastTwoWeekEndDate]
  }, {
    title: 'Этот месяц',
    period: [thisMonthDate, currentDate]
  }, {
    title: 'Прошлый месяц',
    period: [lastMonthStartDate, lastMonthEndDate]
  }];

  return hotChanges;
}

var WEEKDAYS_LONG = {
  ru: ['Воскресение', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота']
};
var WEEKDAYS_SHORT = {
  ru: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
};
var MONTHS = {
  ru: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
};

var defaultLanguage = exports.defaultLanguage = 'ru';

function formatDay(d) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultLanguage;

  return String(WEEKDAYS_LONG[locale][d.getDay()]) + ', ' + String(d.getDate()) + ' ' + String(MONTHS[locale][d.getMonth()]) + ' ' + String(d.getFullYear());
}

function formatMonthTitle(d) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultLanguage;

  return '' + String(MONTHS[locale][d.getMonth()]);
}

function formatYearTitle(d) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultLanguage;

  return d.getMonth() === 0 ? d.getFullYear() : '';
}

function getMonth(d, countMonth, maxPostMonth) {
  var months = [];
  var diffDate = new Date(new Date() - d);
  var diffMonth = diffDate.getMonth() + (diffDate.getFullYear() - new Date(0).getFullYear()) * 12;

  if (diffMonth > Math.abs(maxPostMonth)) {
    diffMonth = Math.abs(maxPostMonth) * -1;
  } else {
    diffMonth *= -1;
  }
  for (var i = countMonth + diffMonth - 1; i >= diffMonth; i--) {
    var date = new Date(d);
    date.setDate(1);
    date.setMonth(date.getMonth() - i);
    months.push(date);
  }
  return months;
}

function formatWeekdayShort(i) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultLanguage;

  return WEEKDAYS_SHORT[locale][i];
}

function formatWeekdayLong(i) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultLanguage;

  return WEEKDAYS_SHORT[locale][i];
}

var localeUtils = exports.localeUtils = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  getPeriods: getPeriods,
  getMonth: getMonth,
  formatYearTitle: formatYearTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  OPTIONS_DATE_CALENDAR: OPTIONS_DATE_CALENDAR
};

exports['default'] = localeUtils;